import $ from "jquery";
import "bootstrap/js/dist/alert";
import GoogleMapsLoader from "google-maps-api-loader";
import "../components/ContactForm7";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let logoTl = gsap.timeline({
  scrollTrigger: {
    trigger: ".map",
    start: "top 30%",
  },
});

logoTl.to(".logo__helper", {
  height: 0,
  duration: 1,
  ease: "none",
});

const $textarea = $("textarea.form-control");

$textarea.css({
  "overflow-y": "hidden",
});

function adjustHeight() {
  $textarea.css("min-height", "130px");
  $textarea.css("height", $textarea[0].scrollHeight + "px");
}

$textarea.on("input", adjustHeight);

adjustHeight();

// Google Maps Configuration
const initGoogleMaps = async () => {
  const $map = $("#map");
  if (!$map.length) return;

  try {
    const apiKey = $map.data("api-key");
    const centerCoords = $map
      .data("center")
      .split(",")
      .map((coord) => parseFloat(coord.trim()));
    const markerCoords = $map
      .data("marker")
      .split(",")
      .map((coord) => parseFloat(coord.trim()));
    const markerIcon = $map.data("marker-icon");

    const google = await GoogleMapsLoader({ apiKey });

    const map = new google.maps.Map($map[0], {
      center: { lat: centerCoords[0], lng: centerCoords[1] },
      zoom: 15,
      disableDefaultUI: true,
      styles: [
        {
          featureType: "administrative",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#444444",
            },
          ],
        },
        {
          featureType: "landscape",
          elementType: "all",
          stylers: [
            {
              color: "#f2f2f2",
            },
          ],
        },
        {
          featureType: "landscape",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#f3eeea",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "all",
          stylers: [
            {
              saturation: -100,
            },
            {
              lightness: 45,
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "all",
          stylers: [
            {
              visibility: "simplified",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "transit",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "all",
          stylers: [
            {
              color: "#46bcec",
            },
            {
              visibility: "on",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#9fd5e2",
            },
          ],
        },
      ],
    });

    new google.maps.Marker({
      position: { lat: markerCoords[0], lng: markerCoords[1] },
      map: map,
      icon: markerIcon,
    });
  } catch (error) {
    console.error("Google Maps initialization error:", error);
    $map.html('<p class="map-error">Unable to load map. Please try again later.</p>');
  }
};

// Initialize Google Maps
$(document).ready(function () {
  initGoogleMaps();
});
